// Drag and Drop Directive
// dnd.directive.ts
import { Directive, EventEmitter, HostBinding, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[appDnd]',
  standalone: true
})
export class DndDirective {
  @Output() fileDropped = new EventEmitter<any>();
  
  @HostBinding('class.fileover') fileOver: boolean = false;
  
  // Dragover listener
  @HostListener('dragover', ['$event']) onDragOver(evt: any) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = true;
    console.log('DragOver event');
  }
  
  // Dragleave listener
  @HostListener('dragleave', ['$event']) onDragLeave(evt: any) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = false;
    console.log('DragLeave event');
  }
  
  // Drop listener
  @HostListener('drop', ['$event']) onDrop(evt: any) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = false;
    
    const files = evt.dataTransfer.files;
    console.log('Drop event with files:', files);
    
    if (files.length > 0) {
      this.fileDropped.emit(files);
    }
  }
}